// Import model
import { StartLeadEditNextAppointmentRequest } from '../models/StartLeadEditNextAppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartLeadEditNextAppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class StartLeadEditNextAppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a StartLeadEditNextAppointmentRequest instance
   */
  static deserialize(json: string): StartLeadEditNextAppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartLeadEditNextAppointmentRequest instance
   */
  static fromObject(obj: any): StartLeadEditNextAppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartLeadEditNextAppointmentRequest');
    }


    const instance: StartLeadEditNextAppointmentRequest = {
      id: obj['_id'] as string | undefined,
      nextAppoitmentId: obj['NextAppoitmentId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartLeadEditNextAppointmentRequest instances
   */
  static deserializeArray(json: string): StartLeadEditNextAppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartLeadEditNextAppointmentRequest instance to a JSON string
   */
  static serialize(instance: StartLeadEditNextAppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartLeadEditNextAppointmentRequest instance to a plain object
   */
  static toObject(instance: StartLeadEditNextAppointmentRequest): any {
    return {
      '_id': instance.id,
      'NextAppoitmentId': instance.nextAppoitmentId,
    };
  }

  /**
   * Serializes an array of StartLeadEditNextAppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: StartLeadEditNextAppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
